module.exports = {
      id: "gears-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "svg-sprite-1d11361007108583c67c4a96e18e035a.svg#gears",
      toString: function () {
        return this.url;
      }
    }